import { render } from "./ExceptionReport.vue?vue&type=template&id=23213c27&scoped=true"
import script from "./ExceptionReport.vue?vue&type=script&lang=js"
export * from "./ExceptionReport.vue?vue&type=script&lang=js"

import "ag-grid-community/dist/styles/ag-theme-alpine.css?vue&type=style&index=0&lang=css"
import "ag-grid-community/dist/styles/ag-grid.css?vue&type=style&index=1&lang=css"
import "./ExceptionReport.vue?vue&type=style&index=2&id=23213c27&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2433923721/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23213c27"]])

export default __exports__